import SettingConfig from '@module/config/setting';
import { VIP_DECO_CODE_TO_SVG_SRC } from '@module/constants/badge';
import BaseSVG from '../image/BaseSVG';

type BaseSVGProps = Omit<Parameters<typeof BaseSVG>[0], 'src' | 'width' | 'height'>;

interface Props extends BaseSVGProps {
  vipDecoCode?: number;
}

function VipDecoBadge({ vipDecoCode, className, ...baseSVGProps }: Props) {
  if (!vipDecoCode) return null;
  const svgpath = VIP_DECO_CODE_TO_SVG_SRC[vipDecoCode];
  if (!svgpath) return null;

  const src = SettingConfig.S3_BUCKET_URL + svgpath;

  return <BaseSVG className={className} src={src} width={64} height={16} {...baseSVGProps} />;
}

export default VipDecoBadge;
